/**
 * A keycap hint in the aip frosted-chip vocabulary — the same token the
 * palette footer, the toolbar affordance and the top-bar button share, so
 * the shortcut always LOOKS like the same shortcut.
 */

import { cn } from '@/lib/utils';

export function KbdChip({ children, className }) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center rounded-full bg-white/50 px-2 py-0.5 text-[11px] font-medium',
        'text-zinc-600 shadow-sm backdrop-blur-[8px] dark:bg-zinc-800/50 dark:text-zinc-300',
        'font-sans not-italic',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
